import Vue from "vue";

Vue.directive("ga-event", {
    inserted(element, binding, vnode) {
        let params = binding.value;

        if (params != null) {
            const category = params[0];
            const action = params[1];
            const label = params.length > 2 ? params[2] : window.location.href;
            element.addEventListener(binding.arg, () => {
                vnode.context.$root.context.$ga.event({
                    eventCategory: category,
                    eventAction: action,
                    eventLabel: label,
                });
            });
        }
    },
});
